<!-- Point Rect -->
@if ((!applicationStateService.pageEditMode || (applicationStateService.pageEditMode && rect.id > 0))) {
    @if (!rect.open) {
        <div (click)="toggleIsExpanded()"
             (keydown)="stopEvent($event)"
             (scroll)="stopEvent($event)"
             (swipeleft)="stopEvent($event)"
             (swiperight)="stopEvent($event)"
             (touchstart)="preventDefault($event)"
             (wheel)="stopEvent($event)"
             [attr.id]="'point-rect-small-' +rect.id"
             class="point-rect-small">
            <svg class="grow" height="25px" version="1.1" viewBox="0 0 25 25" width="25px"
                 xmlns="http://www.w3.org/2000/svg">
                <defs></defs>
                <g fill="none" fill-rule="evenodd" id="EXPORT" stroke="none" stroke-width="1">
                    <g id="icon-note-symbol-blue" stroke="#7D868E" transform="translate(-930.000000, -201.000000)">
                        <g transform="translate(930.000000, 201.000000)">
                            <path fill="#fff79b"
                                  d="M3.2048565,0.5 C2.26431807,0.5 1.89540921,0.571239588 1.5147423,0.774822479 C1.19446913,0.946106445 0.946106445,1.19446913 0.774822479,1.5147423 C0.571239588,1.89540921 0.5,2.26431807 0.5,3.2048565 L0.5,21.7951435 C0.5,22.7356819 0.571239588,23.1045908 0.774822479,23.4852577 C0.946106445,23.8055309 1.19446913,24.0538936 1.5147423,24.2251775 C1.89540921,24.4287604 2.26431807,24.5 3.2048565,24.5 L16.3239882,24.5 C16.8885803,24.5 17.0942589,24.4845175 17.3137311,24.4351569 C17.5039973,24.3923649 17.6686724,24.3257005 17.8351251,24.2240841 C18.0271284,24.1068694 18.1856554,23.9749127 18.5912507,23.5821575 L23.519742,18.809689 C23.9356716,18.4069267 24.0764469,18.2470543 24.2022178,18.0506871 C24.311108,17.8806759 24.3831187,17.7107052 24.4295036,17.5142127 C24.4830794,17.2872588 24.5,17.0749134 24.5,16.495936 L24.5,3.2048565 C24.5,2.26431807 24.4287604,1.89540921 24.2251775,1.5147423 C24.0538936,1.19446913 23.8055309,0.946106445 23.4852577,0.774822479 C23.1045908,0.571239588 22.7356819,0.5 21.7951435,0.5 L3.2048565,0.5 Z" id="Rectangle-17-Copy"></path>
                            <path d="M17.0005825,24.5543905 C16.7826987,24.1469831 16.6666667,23.7428753 16.6666667,22.6284768 L16.6666667,19.8715232 C16.6666667,18.7571247 16.7826987,18.3530169 17.0005825,17.9456095 C17.2184664,17.5382021 17.5382021,17.2184664 17.9456095,17.0005825 C18.3530169,16.7826987 18.7571247,16.6666667 19.8715232,16.6666667 L22.6284768,16.6666667 C23.7428753,16.6666667 24.1469831,16.7826987 24.5543905,17.0005825"
                                  id="Rectangle-14"></path>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    }
    @if (rect.open) {
        <div (keydown)="stopEvent($event)"
             (mousedown)="onMouseDown($event)"
             (mouseup)="resetCursor()"
             (scroll)="stopEvent($event)"
             (swipeleft)="stopEvent($event)"
             (swiperight)="stopEvent($event)"
             (touchstart)="preventDefault($event)"
             (wheel)="stopEvent($event)"
             (window:resize)="debouncedOnResize()"
             [attr.id]="'point-rect-expanded-'+rect.id"
             [class.small-height]="hasSmallHeight"
             [ngStyle]="{
        'background-color': '#fff79b',
        'height.px': height,
        'width.px': width,
        'left.px': left,
        'top.px': top
     }"
             class="point-rect">
            <div class="note-navigation">
                <div class="d-flex justify-content-end align-items-center">
                    <!-- Colorpicker disabled -->
                    <!---@if (featureActivationService.rectsActivated) {
                        <div
                                (touchstart)="stopEvent($event)"
                                class="dropdown color-picker-container float-end">
                            @if (rect.id > 0) {
                                <button aria-expanded="false" aria-haspopup="true"
                                        data-bs-toggle="dropdown"
                                        data-bs-display="static"
                                        id="dropdownMenuButton"
                                        type="button">
                                    <div [ngStyle]="{
                    'background-color': rect.color.getColorString(true)}" class="inner">
                                    </div>
                                </button>
                            }
                            <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                                @for (noteColor of noteColors; track noteColor) {
                                    <button (tap)="setColor(noteColor)"
                                            [ngStyle]="{
                    'background-color': noteColor.getColorString(true)}"
                                            class="noteColor">
                                    </button>
                                }
                            </div>
                        </div>
                    }-->
                    @if (crudPermitted && rect.id > 0) {
                        <i
                                (click)="toggleIsExpanded()"
                                aria-hidden="true" class="fa fa-times close-icon float-end ms-1"></i>
                    }
                </div>
            </div>
            <div (touchstart)="stopEvent($event)" class="note-content-wrapper">
                <div>
                    <div [attr.id]="'rect-editor-' + rect.id">
                    </div>
                </div>
            </div>
            <div class="note-footer">
                @if (featureActivationService.rectsActivated) {
                    <span (tap)="delete()" class="float-start">
            <i class="fa fa-trash"></i> <span> Löschen</span></span>
                }
                <img [attr.src]="resizeIndicatorIconURL" alt="resizeIndicator" class="resize-indicator float-end">
            </div>
        </div>
    }
}





